import { useAppDispatch } from "Store/hooks";

import { closeProcessActionModal } from "../serviceProcesses.slice";

export const useCloseProcessActionModal = () => {
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(closeProcessActionModal());
  };

  return closeModal;
};
